var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ah-search-filters" },
    [
      _vm._l(_vm.categories, function(category, i) {
        return _c("filter-badge", {
          key: "category-" + i,
          staticClass: "ah-search-filters-item",
          attrs: { filter: category }
        })
      }),
      _vm._v(" "),
      _c("filter-group-badge", {
        attrs: { label: _vm.speciesLabel, filters: _vm.species }
      }),
      _vm._v(" "),
      _c("filter-group-badge", {
        attrs: { label: _vm.therapiesLabel, filters: _vm.therapies }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }